import './App.css';
import React from 'react';
// import * as Icon from 'react-feather';
// import { FileText } from 'react-feather';
import akm from './cover.png';
import Microlink from '@microlink/react';
// import pdfFile from './Articles Authored By Dr. A K Mehta.pdf';
import found from './found.png';

function App() {
  return (
    <div className="App">
          <main className="App-maina">
       <h3> Dr. Arun Kumar Mehta, a retired Indian Administrative Service (IAS) officer of the 1988 AGMUT (Arunachal Pradesh-Goa-Mizoram and Union Territories) cadre, served as the Chief Secretary of Jammu and Kashmir (J&K) from May 31, 2021, until his retirement on November 30, 2023. His tenure as Chief Secretary was marked by significant administrative responsibilities during a transformative period for J&K, following the abrogation of Article 370 in August 2019, which led to the reorganization of the state into a Union Territory.
     </h3>
      <Microlink
  url="https://www.firstpost.com/author/arun-kumar-mehta/"
  size="medium"
  lazy
/> 
</main>
    </div>
  );
}

export default App;